/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-flash': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M96 288h147l-51.1 192L416 224H269l51-192z"/>'
  }
})
